import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { format } from "rut.js";
import axiosInstance from "../../../utils/axiosConfig";

const limit = 30;
export const findDocuments = createAsyncThunk(
  "userShow/findDocuments",
  async (params, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const { sort, page } = state.documentsList;

      const skip = limit * (page - 1);
      const { user } = state.userShow;

      const where = {
        stakeholdersDnis: { contains: format(user?.dni!, { dots: false }) },
        source: "migs",
        sourceOrganization: state.userAuthentication.user?.sourceOrganization,
      };
      const listPromise = axiosInstance.get(`${api.baseURL}document`, {
        params: {
          where,
          sort,
          limit,
          skip,
        },
      });
      const countPromise = axiosInstance.post(`${api.baseURL}document/count`, {
        where,
      });

      if (page === 1) {
        const [{ data: list }, { data: count }] = await Promise.all([listPromise, countPromise]);

        return [list, count];
      } else {
        const { data: list } = await listPromise;

        return [list];
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
